import React from "react";
import { MetaPixel } from "./components/MetaPixel";
import { FloatingCTA } from "./components/FloatingCTA";
import { PurchasePopup } from "./components/PurchasePopup";
import { Hero } from "./components/sections/Hero";
import { Story } from "./components/sections/Story";
import { Pains } from "./components/sections/Pains";
import { Volumes } from "./components/sections/Volumes";
import { Tools } from "./components/sections/Tools";
import { Bonuses } from "./components/sections/Bonuses";
import { Offer } from "./components/sections/Offer";
import { Guarantee } from "./components/sections/Guarantee";
import { BeforeAfter } from "./components/sections/BeforeAfter";
import { AuthorMessage } from "./components/sections/AuthorMessage";
import { Testimonials } from "./components/sections/Testimonials";
import { About } from "./components/sections/About";
import { FAQ } from "./components/sections/FAQ";
import { FinalCTA } from "./components/sections/FinalCTA";
import { Footer } from "./components/sections/Footer";
export function App() {
  return <div className="min-h-screen w-full overflow-x-hidden bg-cream font-sans text-ink" data-id="element-0" data-mp="3ii4t85bsoyq5">
      <MetaPixel data-id="element-1" data-mp="3mjg9vlcoy9m7" />
      <Hero data-id="element-2" data-mp="3rc9em985thya" />
      <main data-id="element-3" data-mp="3rcj7c4kla37o">
        <Story data-id="element-4" data-mp="3rbzn2h7gv2qh" />
        <Pains data-id="element-5" data-mp="3rdatkosaqola" />
        <Volumes data-id="element-6" data-mp="3rcswxr1q28cu" />
        <Tools data-id="element-7" data-mp="3reccfffk0fdk" />
        <Bonuses data-id="element-8" data-mp="5yimri0b7dt" />
        <Offer data-id="element-9" data-mp="6hp9c27i9cj" />
        <Guarantee data-id="element-10" data-mp="4wv3njt0sf7" />
        <BeforeAfter data-id="element-11" data-mp="5ggje8nxyxz" />
        <AuthorMessage data-id="element-12" data-mp="82ovg3doih9" />
        <Testimonials data-id="element-13" data-mp="2zld2xbxu5jcl" />
        <About data-id="element-14" data-mp="2zlv32jnmchps" />
        <FAQ data-id="element-15" data-mp="2zmemy5wtxg6g" />
        <FinalCTA data-id="element-16" data-mp="2zmwit1fkxsdu" />
      </main>
      <Footer data-id="element-17" data-mp="33mowttnqsqql" />
      <FloatingCTA anchorId="first-cta" data-id="element-18" data-mp="33m5a7zn5de68" />
      <PurchasePopup data-id="element-19" data-mp="33n6xd2hftr4b" />
    </div>;
}